import api from '../api/axios';
import { EstudianteDetalle, EstudianteResumen } from '../types/estudiante';

export const estudianteService = {
  /** Estudiantes visibles para el usuario (guiados/evaluados; todos si es coordinador). */
  /** Con `periodo` ("AAAA.S") trae a los que estuvieron ese semestre, y de cada uno
   *  el proceso de ese semestre en vez del último. */
  list: async (periodo?: string): Promise<EstudianteResumen[]> => {
    const { data } = await api.get<EstudianteResumen[]>('estudiantes/', { params: periodo ? { periodo } : {} });
    return data;
  },

  /** Ficha de un estudiante (datos + todos sus procesos). */
  get: async (rut: number): Promise<EstudianteDetalle> => {
    const { data } = await api.get<EstudianteDetalle>(`estudiantes/${rut}/`);
    return data;
  },

  /** El coordinador habilita/deshabilita que el estudiante publique su memoria. */
  setPublicarMemoria: async (rut: number, valor: boolean): Promise<boolean> => {
    const { data } = await api.patch<{ can_publish_memoria: boolean }>(`estudiantes/${rut}/`, { can_publish_memoria: valor });
    return data.can_publish_memoria;
  },

  /**
   * El coordinador le quita el tema al estudiante. Devuelve la ficha ya actualizada.
   *
   * Va sobre el estudiante y no sobre un proceso porque deshace la asignación entera:
   * tema y guía en todos sus procesos abiertos, más la postulación aceptada.
   */
  revocarTema: async (rut: number, motivo: string): Promise<EstudianteDetalle> => {
    const { data } = await api.post<EstudianteDetalle>(`estudiantes/${rut}/`, { motivo });
    return data;
  },

  /**
   * Descarga a Excel exactamente estos procesos (las filas de la tabla a la vista), con
   * todo lo de cada uno: estudiante, paso, período, tema, guía, coguía, comisión y
   * resultado. Por ids y no por filtros: lo que está en curso y la pestaña de paso se
   * deciden en la pantalla, y así el Excel dice lo mismo que se ve.
   */
  exportarExcel: async (instancias: number[]): Promise<void> => {
    const { data } = await api.post('estudiantes/export/', { instancias }, { responseType: 'blob' });
    const url = URL.createObjectURL(data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'estudiantes.xlsx';
    a.click();
    URL.revokeObjectURL(url);
  },
};
